import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Marketing Access moved onto the Staff page as the "Hayven marketing team" group. This legacy path
 * redirects there so old bookmarks and links keep working.
 */
export const Route = createFileRoute('/_auth/$orgId/settings/marketing-access')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/$orgId/settings/staff', params: { orgId: params.orgId }, replace: true });
  },
});
